import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestHoliday } from "../../entity/EntityRequestHoliday";

export class DtoRequestHolidaysGetRes extends EntityRequestHoliday {
  public items: EntityRequestHoliday[]  = [];
}
